import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { X } from 'react-bootstrap-icons';
import { RemoveItemFromSelectionGroup } from '../../../../../../../../../../crud/menu_api/selection_groups';
import { toast } from 'react-toastify';

interface SelectionGroupType {
    readonly selection_group_id: number;
    selection_group_name: string;
    selection_group_description?: string;
    local_id: number;
  }

interface AddItemToGroupModalProps {
    show: boolean;
    handleClose: () => void;
    sg: SelectionGroupType;
    groupItems: any[];
    setGroupItems: (items: any[]) => void;
    item: any;
    onItemRemoved?: (itemId: number) => void; // Nueva prop para notificar al padre
}

const DeleteItemFromGroupModal: React.FC<AddItemToGroupModalProps> = ({
    show,
    handleClose,
    sg,
    groupItems,
    setGroupItems,
    item,
    onItemRemoved}) => {
        const [isLoading, setIsLoading] = useState(false);

        const handleDeleteItem = () => {
            setIsLoading(true);
            RemoveItemFromSelectionGroup(sg.selection_group_id, item.item_id)
                .then(() => {
                    const updatedItems = groupItems.filter((i) => i.item_id !== item.item_id);
                    setGroupItems(updatedItems);
                    
                    // Notify parent component about the removed item
                    if (onItemRemoved) {
                        onItemRemoved(item.item_id);
                    }
                    
                    handleClose();
                    toast.success('Item eliminado del grupo correctamente');
                })
                .catch((error) => {
                    console.error('Error deleting item from group', error);
                    toast.error('Error eliminando item del grupo');
                })
                .finally(() => {
                    setIsLoading(false);
                });
        }

        return (
            <Modal show={show} onHide={handleClose}>
                <Modal.Header>
                    <div className="form-modal-title-container">
                        <Modal.Title className="form-modal-title">Remover Item</Modal.Title>
                    </div>
                    <Button
                        variant="none"
                        className="modal-close-button"
                        onClick={handleClose}
                    >
                        <X size={24} />
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    ¿Está seguro que desea remover el item {item.label} del grupo {sg.selection_group_name}?
                </Modal.Body>
                <Modal.Footer>
                   <div className="form-modal-footer-custom">
                    <Button
                        className="form-button-cancel"
                        onClick={handleClose}
                    >
                        Cerrar
                    </Button>
                    <Button className="form-button-create" onClick={handleDeleteItem}>
                        {isLoading ? (
                            <>
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                Eliminando...
                            </>
                        ) : (
                            'Eliminar'
                        )}
                    </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        );
}

export default DeleteItemFromGroupModal;